import * as R from 'ramda'

import {
  BlogFormInterface,
  CreateBlogInputInterface,
  UpdateBlogInputInterface
} from '../interfaces/blog'
import {
  CategoryFormInterface,
  UpdateCategoryInputInterface
} from '../interfaces/category'
import {
  CompanyFormInterface,
  CreateCompanyInputInterface,
  UpdateCompanyInputInterface
} from '../interfaces/company'
import {
  CreateProductInputInterface,
  ProductFormInterface,
  UpdateProductInputInterface
} from '../interfaces/product'
import {
  FrontendSetting,
  FrontendSettingForm,
  FrontendSettingPromoImageInterface
} from '../interfaces/setting'
import { isURL } from './common'

export const createAndUpdateCompanyFormToApiConvertor = (
  companyDetail: CompanyFormInterface
): UpdateCompanyInputInterface | CreateCompanyInputInterface => ({
  ...R.pick(
    [
      'name',
      'country',
      'profileCategory',
      'contactEmail',
      'establishedYear',
      'description',
      'address',
      'importCountries',
      'exportCountries',
      'linkedUserId',
      'verified'
    ],
    companyDetail
  ),
  establishedYear: companyDetail.establishedYear
    ? new Date(companyDetail.establishedYear).toISOString().substring(0, 4) // get only YYYY
    : undefined,
  galleryFileIds: R.pluck('fileId', companyDetail.galleryFiles),
  certificateFileIds: R.pluck('fileId', companyDetail.certificateFiles),
  bannerFileId: R.pathOr(null, ['bannerFile', 'fileId'], companyDetail),
  logoFileId: R.pathOr(null, ['logoFile', 'fileId'], companyDetail),
  BRFileId: R.pathOr(null, ['BRFile', 'fileId'], companyDetail)
})

export const createAndUpdateCategoryFormToApiConvertor = (
  categoryDetail: CategoryFormInterface
): UpdateCategoryInputInterface | CreateCompanyInputInterface => ({
  ...R.pick(['name', 'remark', 'blogUrl'], categoryDetail),
  type: categoryDetail.type === '' ? undefined : categoryDetail.type,
  blogUrl: categoryDetail.blogUrl === '' ? undefined : categoryDetail.blogUrl,
  imageFileId: R.pathOr(null, ['imageFile', 'fileId'], categoryDetail)
})

// REVIEW: do I need to remove the line breaker from the html string?
export const createAndUpdateBlogFormToApiConvertor = (
  blogDetail: BlogFormInterface
): UpdateBlogInputInterface | CreateBlogInputInterface => ({
  ...R.pick(['slugName', 'title'], blogDetail),
  subtitle: blogDetail.subtitle === '' ? undefined : blogDetail.subtitle,
  content: blogDetail.content === '' ? undefined : blogDetail.content,
  miniIconImageFileId: R.pathOr(
    null,
    ['miniIconImageFile', 'fileId'],
    blogDetail
  )
})

export const createProductFromToApiConvertor = (
  productDetail: ProductFormInterface & { companyId?: string }
): UpdateProductInputInterface | CreateProductInputInterface =>
  R.pick(
    [
      'name',
      'categoryId',
      'companyId',
      'hsCode',
      'brands',
      'packaging',
      'seasonsAvailable'
    ],
    productDetail
  )

export const updateProductFromToApiConvertor = (
  productDetail: ProductFormInterface
): UpdateProductInputInterface | CreateProductInputInterface =>
  R.pick(
    ['name', 'categoryId', 'hsCode', 'brands', 'packaging', 'seasonsAvailable'],
    productDetail
  )

export const updateHomePageSettingFormToApiConvertor = (
  homePageSetting: FrontendSettingForm
): FrontendSetting => ({
  ...homePageSetting,
  inSeasonCategoryIds: R.isEmpty(homePageSetting.inSeasonCategoryIds)
    ? []
    : R.split(',')(homePageSetting.inSeasonCategoryIds.replace(' ', '')),
  featuredVerifiedCompanyNos: R.isEmpty(
    homePageSetting.featuredVerifiedCompanyNos
  )
    ? []
    : R.split(',')(homePageSetting.featuredVerifiedCompanyNos.replace(' ', '')),
  promoBannerImages: (R.not(R.isNil(homePageSetting.promoBannerImages))
    ? R.filter(
        (promoBannerImage: FrontendSettingPromoImageInterface) =>
          R.not(R.isEmpty(promoBannerImage.imageFileUrl)) &&
          isURL(promoBannerImage.imageFileUrl),
        homePageSetting.promoBannerImages
      )
    : []
  ).slice(0, 5)
})
